import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { PorteBeneficiarioRoutingModule } from "./porte-beneficiario-routing.module";
import { PorteBeneficiarioListagemComponent } from "./listagem/porte-beneficiario-listagem.component";
import { PorteBeneficiarioPesquisaComponent } from './pesquisa/porte-beneficiario-pesquisa.component';

@NgModule({
    imports: [
        SharedModule,
        BrowserModule,
        CommonModule,
        PorteBeneficiarioRoutingModule
    ],
    declarations: [
        PorteBeneficiarioListagemComponent,
        PorteBeneficiarioPesquisaComponent
    ]
})
export class PorteBeneficiarioModule{}